<template>
  <div class="example-simple">
    <div v-if="!success.status" class="example-btn" :class="this.disabled?'no-drop':''">
      <file-upload v-if="!this.disabled" class="FITFileUpload" :multiple="true" :size="fileMaxSize" :drop="!this.disabled" v-model="files" @input-filter="inputFilter" @input-file="inputFile" ref="upload">
        <b-row :class="this.disabled?'FITDisabled':''" class="dropDownContainer mx-0 my-2" align-v="center">
          <b-col class="text-center">
            <span class="d-block text-primary remindMsg" :class="this.disabled?'TextDisabled':''">{{$t('fitComponents.components.FITFileUpload.dropFileMsg')}}</span>
          </b-col>
        </b-row>
      </file-upload>
      <b-row v-else class="FITDisabled dropDownContainer mx-0 mt-4 mb-3" align-v="center">   
        <b-col class="text-center">
            <span class="d-block text-primary remindMsg" :class="this.disabled?'TextDisabled':''">{{$t('fitComponents.components.FITFileUpload.dropFileMsg')}}</span>
          </b-col>
        </b-row>
      <FITButton v-if="(files[0]&&showUploadBtn)" :text="$t('fitComponents.components.FITFileUpload.upload')" variant="success" faIcon="fa-upload" @click="uploadFiles">
      </FITButton>
    </div>
    <div class="upload py-2">
      <div v-if="!success.status">
        <span v-if="files[0]&&showUploadBtn" class="text-danger remindMsg">{{$t('fitComponents.components.FITFileUpload.uploadRemindMsg')}}</span>
        <div v-if="!this.validation.hide">
        <span class="text-danger remindMsg">{{$t('fitComponents.components.FITFileUpload.oversizeMsg')}}:</span><br/>
        <span v-for="name in this.validation.fileName" class="text-danger remindMsg">{{name}}</span>
      </div>
      </div>
      <div v-else>
        <span v-if="files[0]" class="remindMsg text-success font-weight-bold">{{$t('fitComponents.components.FITFileUpload.successMsg')}}</span>
      </div>
      <div class="table-responsive">
        <table v-if="(files[0])||(this.uploadedFiles.length > 0)" class="my-2 table table-striped table-condensed ">
          <thead>
            <tr class="text-center">
              <th colspan="4" class="text-left">{{$t('fitComponents.components.FITFileUpload.fileName')}}</th>
              <th colspan="1">{{$t('fitComponents.components.FITFileUpload.size')}}</th>
              <th colspan="1">{{$t('fitComponents.components.FITFileUpload.publicDocument')}}</th>
              <th colspan="1">{{$t('fitComponents.components.FITFileUpload.documentTag')}}</th>
              <th colspan="1">{{$t('fitComponents.components.FITFileUpload.remarks')}}</th>
              <th colspan="1">{{$t('fitComponents.components.FITFileUpload.remove')}}</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(file,index) in this.uploadedFiles">
              <tr class="text-center ">
                <td colspan="4" class="text-left align-middle" ><a href="#" @click="fileDownload(file.ID)">{{ file.fileName }}</a></td>
                <td class="align-middle" colspan="1">{{ file.size | formatSize }}</td>
                <td class="align-middle" colspan="1"> {{file.publicDocument}} </td>
                <td class="align-middle colspanMaxWidth" colspan="1">
                  <FITTextInput class="uploadFileInput" :placeholder="file.documentTag" :disabled="true"></FITTextInput>
                </td>
                <td class="align-middle colspanMaxWidth" colspan="1">
                  <FITTextInput class="uploadFileInput" :placeholder="file.remarks" :disabled="true"></FITTextInput>
                </td>
                <td class="align-middle colspanMaxWidth" colspan="1">
                  <i v-if="oldFileRemovable" class='px-2 py-2 fa fa-times' @click="removeUploadedFile(file.ID,index)"></i>
                </td>
              </tr>
            </template>
            <template v-for="(file,index) in files">
              <tr :key="file.id + '-info'" class="text-center ">
                <td colspan="4" class="text-left align-middle">{{ file.name }}</td>
                <td class="align-middle" colspan="1">{{ file.size | formatSize }}</td>
                <td class="align-middle" colspan="1">
                  <FITCheckbox :label="$t('fitComponents.components.FITFileUpload.isPublic')" v-model="file.publicDocument=true" :disabled="success.status"></FITCheckbox>
                </td>
                <td class="align-middle colspanMaxWidth" colspan="1">
                  <FITTextInput class="uploadFileInput" v-model="file.documentTag" :disabled="success.status" placeholder="Tag1, Tag2, ..."></FITTextInput>
                </td>
                <td class="align-middle colspanMaxWidth" colspan="1">
                  <FITTextInput class="uploadFileInput" v-model="file.remarks" :disabled="success.status" placeholder='Remarks'></FITTextInput>
                </td>
                <td class="align-middle" colspan="1">
                  <i v-if="!success.status" class='px-2 py-2 fa fa-times' @click="removeFile(index)"></i>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<style>
.example-simple label.btn {
  margin-bottom: 0;
  margin-right: 1rem;
}

</style>
<script>
import FITButton from '../Button/FITButton'
import FITCheckbox from './FITCheckbox'
import FITTextInput from './FITTextInput'
import FileUpload from 'vue-upload-component'
import FITInputTag from './FITInputTag'
import { API, APIList } from '@/api'

export default {
  name: 'FITWorkflowFileUpload',
  components: {
    FileUpload,
    FITButton,
    FITCheckbox,
    FITTextInput,
    FITInputTag
  },
  props: {
    linkedEntity: {
      type: String,
      default: 'L'
    },
    linkedEntityID: {
      type: String,
      default: '10'
    },
    showUploadBtn: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    //       uploadedFileFields:['fileName','size','publicDocument','documentTag','remarks'],
    oldFileRemovable: {
      type: Boolean,
      default: false
    },
    uploadedFiles: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      files: [],
      fileMaxSize:20971520 ,// 20 MB
      chunkEnabled: false,
      // 1MB by default
      chunkMinSize: 1,
      chunkMaxActive: 3,
      chunkMaxRetries: 5,
      api: new APIList(),
      FITInputTag: {
        limit: '10',
      },
      success: { status: false },
      uploadedFileFields: ['fileName', 'size', 'publicDocument', 'documentTag', 'remarks'],

      validation:{
        fileName:[],
        fileSize:'20MB',
        hide:true,
      }
    }
  },
  created() {
    // console.log(this.uploadedFiles);
  },
  methods: {
    fileDownload(ID){
        this.api.fileDownload(ID);
    },
    inputFilter(newFile, oldFile, prevent) {
      if(this.disabled){
        return prevent();
      }
      if (newFile && !oldFile) {
        // Before adding a file
        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent()
        }
        // Filter php html js file
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent()
        }
        // File Size Validation
          let fileSize = newFile.size | this.formatSize;
         if(fileSize > this.fileMaxSize){
          if(this.validation.fileName.includes(newFile.name)){
            return prevent();
          }
          this.validation.fileName.push( newFile.name );
          this.validation.hide = false;
          
        }

      }
    },
    inputFile(newFile, oldFile) {
      if (newFile && !oldFile) {
        // add
        // console.log('add', newFile)
        this.$refs.upload.active = true
      }
      if (newFile && oldFile) {
        // update
        // console.log('update', newFile)
      }
      if (!newFile && oldFile) {
        // remove
        console.log('remove', oldFile)
      }

    },
    uploadFiles() {
      if(this.validation.hide != true){
        return; 
      }

      if (confirm('Confirm to upload files?')) {
        var files = this.files;
        // console.log(files);
        var data = new FormData();

        for (var i = 0; i < files.length; i++) {
          let item = files[i];
          // console.log(item);
          // add file
          data.append('files[]', item.file);

          // add publickDocument 
          if (!item.publicDocument) {
            item.publicDocument = 'N';
          } else if (item.publicDocument == true) {
            item.publicDocument = 'Y';
          }
          data.append('attachment[publicDocument][]', item.publicDocument);
          // add remarks
          if (item.remarks) {
            data.append('attachment[remarks][]', item.remarks);
          } else {
            data.append('attachment[remarks][]', '');
          }
          //add documentTags
          if (item.documentTag) {
            // let tags = item.documentTags.join(',');
            data.append('attachment[documentTag][]', item.documentTag);
          } else {
            data.append('attachment[documentTag][]', '');
          }

        };
        data.append('linkedEntity', this.linkedEntity);
        data.append('linkedEntityID', this.linkedEntityID);
        // console.log(data);

        this.api.fileUpload(data,
          (json) => {
            // console.log(json);
            if (json.status == 200) {
              // alert(this.$t('fitComponents.components.FITFileUpload.successMsg'))
              this.lockFiles();
            } else {
              alert(this.$t('fitComponents.components.FITFileUpload.errorMsg'))
            }
            // console.log(this.options);
          },
          (error) => {
            console.error(error);
            alert(this.$t('fitComponents.components.FITFileUpload.errorMsg'))

          });

      }
    },
    formUploadFiles() {
      if(this.validation.hide != true){
        return; 
      }
      // Upload Files with forms
      var files = this.files;
      // console.log(files);
      var data = {};
      data.files = [];
      data.attachment = {};
      data.attachment.publicDocument = [];
      data.attachment.documentTag = [];
      data.attachment.remarks = [];
      for (var i = 0; i < files.length; i++) {
        let item = files[i];
        // console.log(item);
        // add file
        data.files.push(item.file);

        // add publickDocument 
        if (!item.publicDocument) {
          item.publicDocument = 'N';
        } else if (item.publicDocument == true) {
          item.publicDocument = 'Y';
        }
        data.attachment.publicDocument.push(item.publicDocument);
        // add remarks
        if (item.remarks) {
          data.attachment.remarks.push(item.remarks);
        } else {
          data.attachment.remarks.push('');
        }
        //add documentTags
        if (item.documentTag) {
          data.attachment.documentTag.push(item.documentTag);
        } else {
          data.attachment.documentTag.push('');
        }

      };
      // data.append('linkedEntity', this.linkedEntity);
      // data.append('linkedEntityID', this.linkedEntityID);
      console.log(data);
      // this.lockFiles();
      // this.$emit('input', data);
      return data;

    },
    checkAllFileSize(){
      let files = this.files;
      let validationState = true;
      for (var i = files.length - 1; i >= 0; i--) {
        let result = ((files[i].size | this.formatSize) < this.fileMaxSize)? true : false;
        validationState = validationState && result;
        console.log('result:' + result);
      }
      this.validation.hide = validationState;
      if(validationState){
        this.validation.fileName  = [];
      }
      return validationState;
    },
    removeAllFile() {
      console.debug('removed');
      // this.files.length = 0;
      this.files.splice(0, this.files.length)
    },
    removeFile(index) {
      let removedFile = this.files[index];
      let removedFileName = removedFile.name;
      let removedIndex = this.validation.fileName.indexOf(removedFileName);
      if (removedIndex > -1) {
        this.validation.fileName.splice(removedIndex, 1);
      }
      this.files.splice(index, 1);
      this.checkAllFileSize();
    },
    removeUploadedFile(id, index) {
      this.$store.dispatch('deleteDocument', id).then(() => {
        this.$emit('onRemoveOldFile', index);
      });
    },
    lockFiles() {
      // console.log(this.$refs);
      this.success.status = true;
    },
    unlockFiles() {
      // console.log("unlocked");
      this.success.status = false;
    }
  }
}

</script>
<style scoped>
.chunk-loading {
  margin: -12px;
  display: flex;
  width: calc(100% + 24px);
}

.chunk-loading .chunk-loading-part {
  height: 25px;
  line-height: 25px;
  flex: 1;
  background: #ccc;
  font-size: 14px;
  color: white;
  text-align: center;
}

.chunk-loading .chunk-loading-part.chunk-loading-part__uploaded {
  background: #28A745;
}

.uploadFileInput {
  margin: 0px !important;
}

.colspanMaxWidth {
  max-width: 200px;
}

.dropDownContainer {
  background-color: #f1f9ff;
  height: 100px;
  width: 100%;
  border: dotted 1px #ccc;
}

.FITFileUpload {
  width: 100%;
  cursor: pointer;
}

.FITDisabled {
  background-color: rgba(231, 231, 231, 0.3) !important;
   cursor:no-drop !important;

}

.TextDisabled {
  color: #999 !important;
}

.no-drop{
     cursor:no-drop !important;

}


</style>



// WEBPACK FOOTER //
// src/components/Form/FITWorkflowFileUpload.vue